import { createFeatureSelector, createSelector } from '@ngrx/store';
import { transmissionFeatureKey, TransmissionState } from '../reducers/transmission.reducer';

export const selectTransmission = createFeatureSelector<TransmissionState>(transmissionFeatureKey);
export const getTransmission = createSelector(selectTransmission, (data) => data.transmission);
export const getTransmissionFetched = createSelector(selectTransmission, (data) => !!data.transmission);

export const getTransmissionById = (props: { id: number }) => createSelector(getTransmission, (data) => data?.find((d) => d.Id === props.id) || null);
